__turbopack_context__.v({
  "container": "prHyMW_container",
  "header": "prHyMW_header",
  "innerContainer": "prHyMW_innerContainer",
  "pagination": "prHyMW_pagination",
  "paginationButton": "prHyMW_paginationButton",
  "paginationText": "prHyMW_paginationText",
  "profile": "prHyMW_profile",
  "statusDetails": "prHyMW_statusDetails",
  "userDetailsContent": "prHyMW_userDetailsContent",
});
